import { Box, Button, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

import TimesheetTable from './Table';
import { FlaggingModal } from './TimesheetModal';
import { TimesheetContentProps } from '../../interface/timesheet';
import { Pagination } from '../Pagination';
import { FilterTimesheetInputs } from '../FilterInputs';

export default function TimesheetContent({
  timesheetList,
  loading,
  setFilterData,
  paginationState,
  setPaginationState,
}: TimesheetContentProps) {
  const [open, setOpen] = useState(false);
  const handleModal = () => setOpen(!open);
  const [compare, setCompare] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');
console.log(timesheetList)
  return (
    <Box
      sx={{
        padding: 3,
        display: 'flex',
        flexDirection: 'column',
        minHeight: '80vh',
        justifyContent: 'space-between',
      }}
    >
      <Box>
        <FlaggingModal
          employeeId={selectedEmployeeId}
          open={open}
          modalHandler={handleModal}
        />
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          sx={{ paddingX: 2 }}
        >
          <Typography
            variant="subtitle2"
            color={'neutral'}
            sx={{ fontWeight: 700, fontFamily: 'Outfit' }}
          >
            Timesheets Overview
          </Typography>

          <Button onClick={() => setCompare(!compare)}>
            {compare ? <FilterAltOffIcon /> : <FilterAltIcon />}
          </Button>
        </Stack>
        <Box
          sx={{
            width: '96%',
            background: 'white',
            p: 3,
            mx: 'auto',
            boxShadow:
              '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
          }}
        >
          {compare && (
            <FilterTimesheetInputs
              loading={loading}
              setFilterData={setFilterData}
            />
          )}
          <TimesheetTable
            setSelectedEmployeeId={setSelectedEmployeeId}
            handleModal={handleModal}
            data={timesheetList}
            loading={loading}
          />
        </Box>
      </Box>
      <Box>
        <Pagination
          paginationState={paginationState}
          setPaginationState={setPaginationState}
        />
      </Box>
    </Box>
  );
}
